module.exports = __webpack_public_path__ + "img/7.2f09e618.webp";